import React from 'react';
import ReactDOM from 'react-dom/client';
import SnackbarProvider from '@providers/SnackbarProvider';

import { CssBaseline } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { lightTheme,theme } from '@components/theme';
import { ThemeProvider, useTheme } from '@components/theme-v2/ThemeContext';

// Import theme-v2 global styles (CSS custom properties + base styles)
import '@components/theme-v2/global-styles.css';
// Leaflet map styles (required for LocationMap component)
import 'leaflet/dist/leaflet.css';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import './i18n';
import '@utils/yupValidation';
import App from './App';

// Wrapper component to use theme context for MUI theme
const ThemedApp = () => {
  const { theme: themeMode } = useTheme();
  const muiTheme = themeMode === 'light' ? lightTheme : theme;

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </MuiThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  </React.StrictMode>,
);
